module.exports = ".card h3 {\r\n  text-align: center;\r\n}\r\n"